import resourceBaseUrl from './baseUrl'

const getResourceUrl = (resourceKey: string): string => `${resourceBaseUrl}/resources/${resourceKey}`

export default getResourceUrl
